import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

/**
 * Content Moderation Modal
 * Displays content moderation warnings in Artmosphere's amber/orange aesthetic
 */
const ContentModerationModal = ({ 
  isOpen, 
  onClose, 
  message, 
  matchedKeywords = [] 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 overflow-hidden transform transition-all duration-300">
        {/* Top Banner - Amber/Orange Gradient */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-400 text-white text-center py-4">
          <div className="flex items-center justify-center gap-3">
            <FaExclamationTriangle className="text-2xl" />
            <h3 className="text-xl font-bold">Content Moderation</h3>
          </div>
        </div>
        
        {/* Content */}
        <div className="p-6">
          {/* Main Message */}
          <p className="text-amber-800 text-center mb-4 leading-relaxed">
            {message}
          </p>
          
          {/* Highlighted Keywords Section */}
          {matchedKeywords && matchedKeywords.length > 0 && (
            <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-4 mb-4">
              <p className="text-sm font-semibold text-amber-800 mb-2">
                Words to remove or modify:
              </p>
              <div className="flex flex-wrap gap-2">
                {matchedKeywords.map((keyword, index) => (
                  <span
                    key={index}
                    className="inline-block bg-amber-200 text-amber-900 px-3 py-1 rounded-lg text-sm font-medium border border-amber-300"
                  >
                    "{keyword}"
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {/* Footer Message */}
          <p className="text-sm text-amber-700 text-center italic">
            Please ensure your content is appropriate for all audiences.
          </p>
        </div>
        
        {/* Close Button */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-amber-500 to-orange-400 hover:from-amber-600 hover:to-orange-500 text-white font-semibold py-3 px-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentModerationModal;
